import * as tslib_1 from "tslib";
import { Injectable, EventEmitter } from '@angular/core';
var NavbarService = /** @class */ (function () {
    function NavbarService() {
        this.visibilityChangeEvent = new EventEmitter();
        this.visible = true;
    }
    NavbarService.prototype.changeVisibility = function (value) {
        this.visible = value;
        this.visibilityChangeEvent.emit(value);
    };
    NavbarService.prototype.hide = function () {
        this.changeVisibility(false);
    };
    NavbarService.prototype.show = function () {
        this.changeVisibility(true);
    };
    NavbarService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], NavbarService);
    return NavbarService;
}());
export { NavbarService };
//# sourceMappingURL=navbar.service.js.map